
import { defineComponent } from 'vue';

import Modal from '~/components/modals/modal.vue';

export default defineComponent({
    components: {
        Modal,
    },

    data() {
        return {
            show: false,
            currentTab: 'AQI',
        }
    },

    methods: {
        open(): void {
            if(!this.$refs.modal) {
                return;
            }
            (<typeof Modal>this.$refs.modal).open();
        }
    }
});
